/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const Calendar = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--calendar"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00065 0.333008C3.31875 0.333008 0.333984 3.31778 0.333984 6.99967V22.9997C0.333984 23.4563 0.379891 23.9022 0.467342 24.333H3.00065V9.66634H27.0007V24.333H29.534C29.6214 23.9022 29.6673 23.4563 29.6673 22.9997V6.99967C29.6673 3.31778 26.6825 0.333008 23.0007 0.333008H7.00065ZM28.3345 26.9997H23.0007H7.00065H1.66683C2.8831 28.6189 4.81956 29.6663 7.00065 29.6663H23.0007C25.1817 29.6663 27.1182 28.6189 28.3345 26.9997ZM3.00065 6.99967C3.00065 4.79054 4.79151 2.99967 7.00065 2.99967H23.0007C25.2098 2.99967 27.0007 4.79054 27.0007 6.99967H3.00065ZM9.66732 12.333H5.66732V16.333H9.66732V12.333ZM5.66732 18.9997H9.66732V22.9997H5.66732V18.9997ZM13.0007 12.333H17.0007V16.333H13.0007V12.333ZM17.0007 18.9997H13.0007V22.9997H17.0007V18.9997ZM24.334 12.333H20.334V16.333H24.334V12.333ZM20.334 18.9997H24.334V22.9997H20.334V18.9997Z"
        fill="currentColor"
      />
    </svg>
  );
};

Calendar.displayName = "Calendar";

export default Calendar;
